(function() {
  'use strict';

  var SELECTORS = {
    filterToggle: '[data-hc-filter-toggle]',
    filterPanel: '[data-hc-filter-panel]',
    filterApply: '[data-hc-filter-apply]',
    filterForm: '[data-collection-filters-form]',
    filterCount: '[data-hc-filter-count]',
    filterCheckbox: '.hc-grid-filters__checkbox',
    sortToggle: '[data-hc-sort-toggle]',
    sortList: '[data-hc-sort-list]',
    sortWrapper: '[data-hc-sort-wrapper]'
  };

  function updateFilterCount() {
    var countEl = document.querySelector(SELECTORS.filterCount);
    if (!countEl) return;

    var checkboxes = document.querySelectorAll(SELECTORS.filterCheckbox + ':checked');
    var count = checkboxes.length;

    var priceMin = document.querySelector('[data-field-price-min]');
    var priceMax = document.querySelector('[data-field-price-max]');
    if (priceMin && priceMin.value !== '' && priceMin.value !== priceMin.placeholder) count++;
    if (priceMax && priceMax.value !== '' && priceMax.value !== priceMax.placeholder) count++;

    countEl.textContent = count;
    if (count > 0) {
      countEl.classList.remove('hc-grid-nav__filters-count--hidden');
    } else {
      countEl.classList.add('hc-grid-nav__filters-count--hidden');
    }
  }

  function initFilterToggle() {
    var toggleBtn = document.querySelector(SELECTORS.filterToggle);
    var panel = document.querySelector(SELECTORS.filterPanel);

    if (!toggleBtn || !panel) return;

    toggleBtn.addEventListener('click', function() {
      var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!isExpanded));

      if (isExpanded) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');

        requestAnimationFrame(function() {
          var rangeSlider = panel.querySelector('range-slider');
          if (rangeSlider && typeof rangeSlider.connectedCallback === 'function') {
            rangeSlider.connectedCallback();
          }
          document.dispatchEvent(new CustomEvent('theme:resize:width'));
        });
      }
    });
  }

  function initFilterCheckboxes() {
    var checkboxes = document.querySelectorAll(SELECTORS.filterCheckbox);
    checkboxes.forEach(function(cb) {
      cb.addEventListener('change', updateFilterCount);
    });
  }

  function initFilterApply() {
    var applyBtn = document.querySelector(SELECTORS.filterApply);
    if (!applyBtn) return;

    applyBtn.addEventListener('click', function() {
      var form = applyBtn.closest('form') || document.querySelector(SELECTORS.filterForm);
      if (!form) return;

      var formData = new FormData(form);
      var params = new URLSearchParams();

      for (var pair of formData.entries()) {
        if (pair[1] !== '' && pair[1] !== undefined) {
          params.append(pair[0], pair[1]);
        }
      }

      var baseUrl = window.location.pathname;
      var queryString = params.toString();
      var newUrl = queryString ? baseUrl + '?' + queryString : baseUrl;

      window.location.href = newUrl;
    });
  }

  function initSortDropdown() {
    var sortWrapper = document.querySelector(SELECTORS.sortWrapper);
    if (!sortWrapper) return;

    var toggleBtn = sortWrapper.querySelector(SELECTORS.sortToggle);
    var list = sortWrapper.querySelector(SELECTORS.sortList);

    if (!toggleBtn || !list) return;

    toggleBtn.addEventListener('click', function() {
      var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!isExpanded));

      if (isExpanded) {
        list.setAttribute('hidden', '');
      } else {
        list.removeAttribute('hidden');
      }
    });

    document.addEventListener('click', function(e) {
      if (!sortWrapper.contains(e.target)) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        list.setAttribute('hidden', '');
      }
    });
  }

  function init() {
    initFilterToggle();
    initFilterCheckboxes();
    initFilterApply();
    initSortDropdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
